module.exports = {
    substitutionsInstructionsLinkText: {
        add: 'Add Instructions',
        hide: 'Hide Instructions',
        show: 'Show Instructions',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/substitutions-instructions-link-text.js